// Copyright (c) Move Closer 2022.

import { Component, Vue } from 'vue-property-decorator'

import { Inject, logger } from '../../../support'
import { ProductData } from '../../../contexts'

import {
  IProductsRepository,
  ProductsRepositoryType
} from '../../products/contracts/repositories'
import { translateProductToProductCard } from '../../products/organisms/ProductCard/ProductCard.helpers'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
@Component
export class SuggestedProductsMixin extends Vue {
  @Inject(ProductsRepositoryType)
  protected readonly productsRepository!: IProductsRepository

  public isLoading: boolean = false

  public suggestedProducts: Array<ProductData> = []

  /**
   * Loads suggested products bound with specific variant
   */
  public async loadSuggestedProducts (sku?: string | null, action?: string | null): Promise<void> {
    this.isLoading = true

    try {
      const response = await this.productsRepository.loadProductsBySkus(
        sku ? [sku] : null,
        action || null
      )

      if (!response) {
        return
      }

      this.suggestedProducts = response
    } catch (e) {
      logger((e as Error).message, 'warn')
    } finally {
      this.isLoading = false
    }
  }

  public translateProductToProductCard = translateProductToProductCard
}
